import $ from "jquery";
import React from "react";
import { MenuItem, SubMenu } from "react-contextmenu";
import { handleUpdateMode } from "../contextLotsDisplays/utils";

export default function RollingGate() {
    const RollingGateModes = [
        { mode: 0, translationKey: "rolltor.modes.Automatic" },
        { mode: 1, translationKey: "rolltor.modes.ManualOpen" },
        { mode: 2, translationKey: "rolltor.modes.ManualClose" },
        { mode: 3, translationKey: "rolltor.modes.Extern" },
    ];
    
    function updateRollingGate(data, document) {
        console.debug('updateRollingGate(%o)', data);

        let newHRef = getHrefForRollingGateStatus(data.status);
        let svgElement = document.getElementById(data.name);
        console.debug('RollingGate? %s => %o', data.name, svgElement);

        $(svgElement).attr("xlink:href", newHRef);
    }
    function getHrefForRollingGateStatus(status) {
        switch (status) {
            default:
            case 0:
                return '#rolltor_Unknown';
            case 1:
                return '#rolltor_Open';
            case 2:
                return '#rolltor_Closed';
            case 3:
                return '#rolltor_Defect';
        }
    }

    const RollingGateContextMenu = (props) => {
        const {
            contextId,
            contextName,
            activeRights,
            showSettings,
            getData,
            t,
        } = props;

        return (
            <div id="contextmenu" className="contextmenu">
                {activeRights.includes("RollingGate.SetMode") && (
                    <SubMenu
                        title={
                            <div className="submenu-title">
                                {" "}
                                {t("allgemein.modus")}{" "}
                                <i className="fas fa-chevron-right submenu-icon"></i>{" "}
                            </div>
                        }
                        className="submenu"
                    >
                        {RollingGateModes.map(({ mode, translationKey }) => (
                            <React.Fragment key={mode}>
                                <MenuItem
                                    onClick={() =>
                                        handleUpdateMode({
                                            contextId,
                                            contextName,
                                            mode,
                                            type: "RollingGate",
                                        })
                                    }
                                >
                                    {t(translationKey)}
                                </MenuItem>
                                <MenuItem divider />
                            </React.Fragment>
                        ))}
                    </SubMenu>
                )}
                {activeRights.some((item) => item.includes("RollingGate.")) && (
                    <>
                        <MenuItem divider />

                        <MenuItem
                            onClick={() =>
                                showSettings({
                                    Data: [getData(contextId)],
                                    Type: "RollingGate",
                                })
                            }
                            className="activeitem"
                        >
                            {t("allgemein.einstellungen")}
                        </MenuItem>
                    </>
                )}
                <MenuItem divider />

                <MenuItem disabled>{contextName}</MenuItem>

                {activeRights.includes("Debug.ShowIds") && (
                    <>
                        <MenuItem divider />
                        <MenuItem disabled>ID: {contextId}</MenuItem>
                    </>
                )}
            </div>
        );
    };
    
    return {
        updateRollingGate, RollingGateModes, RollingGateContextMenu
    };
}